/** @format */

import { NgZone } from '@angular/core';

import { AngularFirestore } from '@angular/fire/firestore';

import { environment } from '../environments/environment';

export function AngularFirestoreProject(platformId: Object, zone: NgZone) {
  return new AngularFirestore(environment.firebaseConfig, 'firebaseProject', false, null, platformId, zone, null, null, null);
}
